<section class="roles-page">
  <div class="page-heading">
    <div>
      <p>Access design</p>
      <h2>Roles</h2>
    </div>
  </div>

  @if (canCreateRole) { <section class="role-builder">
    <h3>{{ isPlatformScope ? 'Create platform admin role' : 'Create business role' }}</h3>
    @if (isPlatformScope) { <p class="state">Create job-based roles such as Listing Reviewer, Catalog Manager or Subscription Manager. Do not share Super Admin access.</p> }
    @if (!isPlatformScope) { <p class="state">Create roles only for users in this business. Available access and role count are controlled by the subscription.</p> }
    @if (!allowCustomRoles) { <p class="state">Role creation is not included in your current subscription plan.</p> }
    <form (ngSubmit)="createRole()">
      <input name="roleName" [(ngModel)]="newRole.name" placeholder="Role name" />
      <input name="description" [(ngModel)]="newRole.description" placeholder="Short description" />
      <button type="submit" [disabled]="isSubmitting || !allowCustomRoles">
        <span class="material-symbols-outlined" aria-hidden="true">admin_panel_settings</span>
        {{ isSubmitting ? 'Adding...' : 'Add role' }}
      </button>
    </form>
  </section> }

  @if (isLoading) {
    <p class="state">Loading roles...</p>
  }

  @if (successMessage) {
    <p class="state success">{{ successMessage }}</p>
  }

  @if (errorMessage) {
    <p class="state error">{{ errorMessage }}</p>
  }

  <section class="role-grid">
    @for (role of roles; track role.id) {
      <article>
        <div class="role-head">
          <div>
            <h3>{{ role.name }}</h3>
            <span>{{ role.isSystemRole ? 'ZepBazaar default' : 'Custom' }}</span>
          </div>
        </div>
        <p class="role-description">{{ role.description || 'No role description provided.' }}</p>
        <div class="role-stats">
          <span><strong>{{ role.users ?? 0 }}</strong><small>Users</small></span>
          <span><strong>{{ permissionCounts[role.id] ?? 0 }}</strong><small>Permissions</small></span>
        </div>
        <div class="chips">
          @for (permission of role.permissions ?? []; track permission) {
            <span>{{ permission }}</span>
          }
        </div>
        @if (isProtectedSuperAdminRole(role)) {
          <p class="protected-role-note">
            <span class="material-symbols-outlined" aria-hidden="true">verified_user</span>
            Protected platform role
          </p>
        } @else if (canAssignPermissions && (isPlatformAdmin || (allowCustomRoles && !role.isSystemRole))) {
          <button
            class="secondary"
            type="button"
            [routerLink]="[permissionsRoute]"
            [queryParams]="{ roleId: role.id, tenantId: isPlatformAdmin ? 'platform' : null }">
            <span class="material-symbols-outlined" aria-hidden="true">tune</span>
            {{ isPlatformAdmin ? 'Manage permissions' : 'Edit permissions' }}
          </button>
        } @else {
          <button class="secondary" type="button" (click)="viewPermissions(role)">
            <span class="material-symbols-outlined" aria-hidden="true">visibility</span>
            View permissions
          </button>
        }
      </article>
    }
  </section>

  @if (permissionRole) {
    <div class="dialog-backdrop" role="presentation" (click)="closePermissionView()">
      <section class="permission-dialog" role="dialog" aria-modal="true" [attr.aria-label]="permissionRole.name + ' permissions'" (click)="$event.stopPropagation()">
        <header><div><small>ROLE ACCESS</small><h3>{{ permissionRole.name }}</h3><p>{{ permissionRole.description }}</p></div><button class="close-button" type="button" aria-label="Close" (click)="closePermissionView()"><span class="material-symbols-outlined">close</span></button></header>
        @if (isRolePermissionsLoading) {
          <p class="permission-state">Loading permissions…</p>
        } @else {
          <div class="permission-groups">
            @for (group of groupedRolePermissions; track group.module) {
              <section><h4>{{ group.module }}</h4>@for (permission of group.permissions; track permission.id) { <div class="permission-item"><span class="material-symbols-outlined">check_circle</span><div><strong>{{ permission.name }}</strong><small>{{ permission.description || permission.code }}</small></div></div> }</section>
            } @empty { <p class="permission-state">No permissions are currently assigned to this role.</p> }
          </div>
        }
      </section>
    </div>
  }
</section>
